import store from "@/store";
import { cpdapi } from 'src/helpers/axios'
import { router } from "../router";
import qs from 'qs'
import { portalapi } from "../helpers/axios";

import { ErrorService } from "../helpers/errorplugin"
const $log = ErrorService

export {
  connectToInternet,
  disconnectFromInternet,
  checkMyStatus,
  startpaywall,
  stoppaywall
}

async function connectToInternet() {

  $log.onDebug("connectToInternet")

  checkMyStatus();

  try {
    
    $log.onTrace('calling refresh in cpd index');
    // Call the refresh token endpoint (/jwt/refresh) to get a new access token
    const response = await portalapi.post('jwt/refresh', {
        refresh: store.getters['account/refreshToken']                      
    });
    
    $log.onTrace('refresh completed');
    store.commit("account/setRefreshToken", response.data.refresh);
    store.commit("account/setAccessToken", response.data.token);
  } catch (error) {
    // Handle errors
    $log.onTrace('Refresh token in connect method failed:', error);
    store.commit("account/clearUserData", "")

    return;
  }

  const accessToken = store.getters['account/accessToken']
  
  let payload = {
    token: accessToken
  }

  let options = {
    method: "POST",
    headers: { "content-type": "application/x-www-form-urlencoded" },
    data: qs.stringify(payload),
    url: "https://cpd.soldiernet.co.uk/connect"
  };

  return cpdapi(options).then(
    (response) => {
      let rd = response
      // set connected in captive vuex
      router.push('/account/info')
      if (response.status === 200) {
        $log.onInfo('cpdapi rc = 200 and response is ' + JSON.stringify(rd))
        // store.commit('captive/setStatus', rd)
        alert(rd.data.connected ? 'You are connected.' : 'Connection failed.\nPlease try again or contact SoldierNET Support.')
      } else {
        $log.onInfo('cpdapi unexpected rc = ' + response.status + ' and rd is ' + JSON.stringify(rd))
        store.commit('captive/setDisconnected')
        alert('Something went wrong.\nPlease try again or contact SoldierNET Support.')
      }
    },
    (error) => {
      store.commit('captive/setDisconnected')
      alert(JSON.stringify(error.response.data.message))
      $log.onDebug("cpd failed during connect:" + error)
      store.commit('captive/setDisconnected')
      // set disconnected in captive vuex
    });
}

function disconnectFromInternet() {
  $log.onDebug("disconnectFromInternet")

  let options = {
    method: "GET",
    url: "https://cpd.soldiernet.co.uk/disconnect"
  };

  return cpdapi(options).then(
    (response) => {
      let rd = response.data
      $log.onDebug(JSON.stringify(rd))
      // set connected in captive vuex
      if (response.status === 200) {
        store.commit('captive/setDisconnected');
        alert('You have now been disconnected.')
      } else {
        store.commit('captive/setDisconnected');
        alert('There was an error when disconnecting your session.\nPlease contact SoldierNET Support if you are unable to connect.')
      }
    },
    (error) => {
      $log.onDebug("cpd failed during disconnect:" + error)
      alert('Something went wrong.\nPlease try again or contact SoldierNET Support.');
    });
}

async function checkMyStatus(){
  // check to see if the device I am currently using is connected
  let options = {
    method: "GET",
    url: "https://cpd.soldiernet.co.uk/status"
  };

  try {
    await cpdapi(options).then((response) => {
      if (response.status === 200) {
        let rd = response.data
        // set state/connected accordingly
        $log.onError("status rd is " + JSON.stringify(rd))
        store.commit('captive/setStatus', rd)
        return rd
      } else {
        return {connected: false}
      }
    },
    (error) => {
      let rd = error.data
      $log.onError("status error rd is " + JSON.stringify(rd))
      // set state/connected accordingly
      store.commit('captive/setStatus', rd)
      return rd
    });
  } catch (e) {    
    $log.onDebug(e);
  }
  
  
}

async function startpaywall(ip, mac){
  $log.onDebug("We are ready to start the paywall - " + store.getters['captive/isOnNet'])

  if ( store.getters['captive/isOnNet'] ) {
    
    $log.onDebug("We are on net")
    // await checkMyStatus()

    await checkMyStatus()
    let connected = store.getters['captive/isConnected']
    
    $log.onDebug("Status is equal to " + JSON.stringify(connected))
    
    if ( ! connected ) {
      $log.onDebug("...but not currently connected, so startpaywall")

    
      $log.onDebug("startpaywall")
      // const accessToken = store.getters['account/accessToken']
      
      // let payload = {
      //   token: accessToken
      // }

      // let options = {
      //   method: "GET",
      //   url: "https://cpd.soldiernet.co.uk/startpaywall"
      // };

      try {
        $log.onDebug("Trying to send POST request for startpaywall now")
        return portalapi.post('startpaywall', {ip: ip, mac: mac, action: 'start paywall'});
        // .then((response) => {
        //   let rd = response.data
          // $log.onDebug("cpd startpaywall returned" + JSON.stringify(rd))
          
        //   return rd
        // });
      } catch (e) {    
        $log.onDebug(e);
        throw e;
      }
    } else {
      $log.onDebug("...and already connected, so no need to startpaywall")
    }
  } else {
    $log.onDebug("We are not onnet")
  }
    
    
}


async function stoppaywall(){
  $log.onDebug("stoppaywall")
  const accessToken = store.getters['account/accessToken']
  
  let options = {
    method: "get",
    url: "https://cpd.soldiernet.co.uk/stoppaywall"
  };

  try {
    await cpdapi(options).then((response) => {
      let rd = response.data
      $log.onDebug("cpd stoppaywall returned" + JSON.stringify(rd))
      
      return rd
    });
  } catch (e) {    
    $log.onDebug(e);
  }
    
  
}